import React, { useEffect, useState,useRef } from "react";
import {
  Box,
  Drawer,
  IconButton,
  Button,
  CircularProgress,
  Checkbox,
} from "@mui/material";
import { useFormik } from "formik";
import CustomText, { textStyles } from "../../../components/CustomText";
import CustomButton from "../../../components/CustomButton";
import profilecross from "../../../assets/profilecross.svg";
import save from "../../../assets/save.svg";
import { BASE_URL } from "../../../components/BaseUrl";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../Utlis/Encryption";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
const AddAbsenceDrawer = ({ open, onClose, onAdded }) => {
  const token = useSelector((state) => state.auth.token);
  const { company } = useSelector((state) => state.auth);
  const companyId = company?.id;
  const decryptedToken = token ? decryptToken(token) : null;
  const { t } = useTranslation()
  const [workers, setWorkers] = useState([]);
  const [types, setTypes] = useState([]);

  const [loadingWorkers, setLoadingWorkers] = useState(false);
  const [loadingTypes, setLoadingTypes] = useState(false);
  const [adding, setAdding] = useState(false);

  // Formik form
  const formik = useFormik({
    initialValues: {
      worker_id: "",
      // absence_type_id: "",
      start_date: "",
      end_date: "",
      comment: "",
      is_partial: false,
      partial_start_time: "",
      partial_end_time: "",
    },
    validate: (values) => {
      const errors = {};

      // Worker ID
      if (!values.worker_id || (typeof values.worker_id === "string" && values.worker_id.trim() === "")) {
        errors.worker_id = t("absence.add.validation.workerRequired") || "Worker is required";
      }

      // Absence Type ID
      // if (!values.absence_type_id || (typeof values.absence_type_id === "string" && values.absence_type_id.trim() === "")) {
      //   errors.absence_type_id = t("absence.add.validation.absenceTypeRequired") || "Absence type is required";
      // }

      // Start Date
      if (!values.start_date || (typeof values.start_date === "string" && values.start_date.trim() === "")) {
        errors.start_date = t("absence.add.validation.startDateRequired") || "Start date is required";
      }

      // End Date
      if (!values.end_date || (typeof values.end_date === "string" && values.end_date.trim() === "")) {
        errors.end_date = t("absence.add.validation.endDateRequired") || "End date is required";
      }

      // Validate end date is after start date
      if (values.start_date && values.end_date && values.start_date > values.end_date) {
        errors.end_date = t("absence.add.validation.endDateAfterStart") || "End date must be after start date";
      }

      // Partial day times (required if is_partial is true)
      if (values.is_partial) {
        if (!values.partial_start_time || (typeof values.partial_start_time === "string" && values.partial_start_time.trim() === "")) {
          errors.partial_start_time = t("absence.add.validation.startTimeRequired") || "Start time is required for partial day";
        }
        if (!values.partial_end_time || (typeof values.partial_end_time === "string" && values.partial_end_time.trim() === "")) {
          errors.partial_end_time = t("absence.add.validation.endTimeRequired") || "End time is required for partial day";
        }
        // Validate end time is after start time
        if (values.partial_start_time && values.partial_end_time && values.partial_start_time >= values.partial_end_time) {
          errors.partial_end_time = t("absence.add.validation.endTimeAfterStart") || "End time must be after start time";
        }
      }

      return errors;
    },
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit: async (values) => {
      try {
        setAdding(true);

        const res = await fetch(`${BASE_URL}/absences/admin/absences`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(values),
        });

        const json = await res.json();

        if (!json.error) {
          toast.success(t("absence.add.added_success") || "Absence added successfully!");
          onAdded?.(); // refresh table
          formik.resetForm();
          onClose();    // close drawer
        } else {
          toast.error(json.message || t("absence.add.added_failed") || "Failed to add absence.");
        }
      } catch (err) {
        toast.error(t("absence.add.network_error") || "Network error when adding absence.");
      } finally {
        setAdding(false);
      }
    },
  });

  // Fetch Workers
  const fetchWorkers = async () => {
    try {
      setLoadingWorkers(true);
      const res = await fetch(
        `${BASE_URL}/public/workers?company_id=${companyId}&no_pagination=true&status=active`,
        // no_pagination=true&company_id=${companyId}&status=active
        { method: "GET", headers: { "Content-Type": "application/json" } }
      );

      const data = await res.json();
      console.log(data)
      setWorkers(data.data?.records || []);
    } catch (err) {
      console.log("Worker fetch error:", err);
    } finally {
      setLoadingWorkers(false);
    }
  };

  // Fetch Absence Types
  const fetchTypes = async () => {
    try {
      setLoadingTypes(true);
      const res = await fetch(`${BASE_URL}/absences/admin/absences/types`, {
        headers: { Authorization: `Bearer ${decryptedToken}` },
      });

      const json = await res.json();
      if (!json.error) setTypes(json.data.absenceTypes);
    } catch (err) {
      console.log("Type Fetch Error:", err);
    } finally {
      setLoadingTypes(false);
    }
  };

  // Trigger fetch when drawer opens
  useEffect(() => {
    if (open) {
      fetchWorkers();
      fetchTypes();
      formik.resetForm();
    }
  }, [open]);



  // Limit year input to max 4 digits when typing inside date field
  const enforceYearLimit = (e, fieldName) => {
    let value = e.target.value;

    // Extract only year part when user is typing manually
    if (value && value.includes("-")) {
      const [year, month, day] = value.split("-");

      // If year exceeds 4 digits → trim it
      const fixedYear = year.slice(0, 4);

      value = [fixedYear, month, day].join("-");
    } else {
      // If user types only year without "-"
      value = value.slice(0, 4);
    }

    formik.setFieldValue(fieldName, value);
    formik.setFieldTouched(fieldName, true);
  };


    const startRef = useRef(null);
    const endRef = useRef(null);
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: { xs: "100%", sm: 400, md: 500 },
          backgroundColor: "#E7EBEE",
        },
      }}
    >
      {/* HEADER */}
      <Box
        sx={{
          px: 2,
          py: 2,
          display: "flex",
          alignItems: "center",
          gap: 1,
          backgroundColor: "#E7EBEE",
        }}
      >
        <IconButton onClick={onClose}>
          <img src={profilecross} alt="close" />
        </IconButton>

        <CustomText
          sx={{
            ...textStyles.h1,
            fontSize: 20,
            fontWeight: 600,
            color: "#2C384C",
          }}
        >
          {t("absence.add.heading")}
        </CustomText>
      </Box>

      {/* BODY */}
      <Box sx={{ px: 2 }}>
        <Box
          sx={{
            backgroundColor: "white",
            px: 3,
            py: 3,
            height: "calc(100vh - 90px)",
            overflowY: "auto",
          }}
        >
          {/* WORKER DROPDOWN */}
          <CustomText sx={{
            ...textStyles.h1,
            fontSize: 15,
            fontWeight: 500,
            color: "#2C384C",
            pt: 1,
            mb: 1,
            textAlign: "left"
          }}>{t("absence.add.worker")} <span className="red_asterisk">*</span></CustomText>

          {loadingWorkers ? (
            <CircularProgress size={22} />
          ) : (
            <>
              <select
                value={formik.values.worker_id}
                onChange={(e) => {
                  formik.setFieldValue("worker_id", e.target.value);
                  formik.setFieldTouched("worker_id", true);
                }}
                onBlur={formik.handleBlur}
                className="project_input"
                style={{
                  width: "100%",
                  height: 40,
                  border: formik.touched.worker_id && formik.errors.worker_id
                    ? "2px solid #d32f2f"
                    : "2px solid #091E4224"
                }}
              >
                <option value="">{t("absence.add.select_worker")}</option>
                {workers.map((w) => (
                  <option key={w.id} value={w.id}>
                    {w.first_name} {w.last_name} ({w.email})
                  </option>
                ))}
              </select>
              {formik.touched.worker_id && formik.errors.worker_id && (
                <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                  {formik.errors.worker_id}
                </span>
              )}
            </>
          )}

          {/* TYPES DROPDOWN */}
          <CustomText sx={{
            ...textStyles.h1,
            fontSize: 15,
            fontWeight: 500,
            color: "#2C384C",
            pt: 1,
            mt: 1,
            textAlign: "left",
            mb: 1,
          }}>{t("absence.add.absence_type")} <span className="red_asterisk">*</span></CustomText>

          {loadingTypes ? (
            <CircularProgress size={22} />
          ) : (
            <>
              <select
                value={formik.values.absence_type_id}
                onChange={(e) => {
                  formik.setFieldValue("absence_type_id", e.target.value);
                  formik.setFieldTouched("absence_type_id", true);
                }}
                onBlur={formik.handleBlur}
                className="project_input"
                style={{
                  width: "100%",
                  height: 40,
                  border: formik.touched.absence_type_id && formik.errors.absence_type_id
                    ? "2px solid #d32f2f"
                    : "2px solid #091E4224"
                }}
              >
                <option value="">{t("absence.add.select_type")}</option>
                {types.map((t) => (
                  <option key={t.id} value={t.id}>
                    {t.name}
                  </option>
                ))}
              </select>
              {formik.touched.absence_type_id && formik.errors.absence_type_id && (
                <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                  {formik.errors.absence_type_id}
                </span>
              )}
            </>
          )}

          {/* DATES */}
          <Box sx={{ mt: 1.5 }}>
            <CustomText sx={{
              ...textStyles.h1,
              fontSize: 15,
              fontWeight: 500,
              color: "#2C384C",
              pt: 1,
              textAlign: "left",
              mb: 1,
            }}>{t("absence.add.start_date")} <span className="red_asterisk">*</span></CustomText>
            <input
             ref={startRef}
                onClick={() => startRef.current?.showPicker()} 
              type="date"
              value={formik.values.start_date}
              onChange={(e) => enforceYearLimit(e, "start_date")}
              onBlur={formik.handleBlur}
              className="project_input"
              style={{
                width: "100%",
                height: 40,
                border: formik.touched.start_date && formik.errors.start_date
                  ? "2px solid #d32f2f"
                  : "2px solid #091E4224"
              }}
            />
            {formik.touched.start_date && formik.errors.start_date && (
              <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                {formik.errors.start_date}
              </span>
            )}
          </Box>

          <Box sx={{ mt: 1.5 }}>
            <CustomText sx={{
              ...textStyles.h1,
              fontSize: 15,
              fontWeight: 500,
              color: "#2C384C",
              pt: 1,
              textAlign: "left",
              mb: 1,
            }}>{t("absence.add.end_date")} <span className="red_asterisk">*</span></CustomText>
            <input
             ref={endRef}
                onClick={() => endRef.current?.showPicker()} 
              type="date"
              value={formik.values.end_date}
              onChange={(e) => enforceYearLimit(e, "end_date")}
              onBlur={formik.handleBlur}
              className="project_input"
              style={{
                width: "100%",
                height: 40,
                border: formik.touched.end_date && formik.errors.end_date
                  ? "2px solid #d32f2f"
                  : "2px solid #091E4224"
              }}
            />
            {formik.touched.end_date && formik.errors.end_date && (
              <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                {formik.errors.end_date}
              </span>
            )}
          </Box>

          {/* COMMENT */}
          <Box sx={{ mt: 1.5 }}>
            <CustomText sx={{
              ...textStyles.h1,
              fontSize: 15,
              fontWeight: 500,
              color: "#2C384C",
              pt: 1,
              textAlign: "left",
              mb: 1,
            }}>{t("absence.add.comment")}</CustomText>
            <textarea
              value={formik.values.comment}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              name="comment"
              className="project_input"
              style={{ width: "100%", minHeight: 80 }}
            />
          </Box>

          {/* PARTIAL DAY CHECKBOX */}
          <Box sx={{ mt: 3, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Checkbox
              checked={formik.values.is_partial}
              onChange={(e) => {
                formik.setFieldValue("is_partial", e.target.checked);
                if (!e.target.checked) {
                  formik.setFieldValue("partial_start_time", "");
                  formik.setFieldValue("partial_end_time", "");
                }
              }}
            />
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 15,
                fontWeight: 500,
                color: "#2C384C",
                textAlign: "right"
              }}>{t("absence.add.partial_day")}</CustomText>
          </Box>

          {/* TIME INPUTS */}
          {formik.values.is_partial && (
            <Box sx={{ mt: 2 }}>
              <CustomText sx={{
                ...textStyles.h1,
                fontSize: 15,
                fontWeight: 500,
                color: "#2C384C",
                pt: 1,
                textAlign: "left",
                mb: 1,
              }}>{t("absence.add.start_time")} <span className="red_asterisk">*</span></CustomText>
              <input
                type="time"
                value={formik.values.partial_start_time}
                onChange={(e) => {
                  formik.setFieldValue("partial_start_time", e.target.value);
                  formik.setFieldTouched("partial_start_time", true);
                }}
                onBlur={formik.handleBlur}
                className="project_input"
                style={{
                  width: "100%",
                  height: 40,
                  border: formik.touched.partial_start_time && formik.errors.partial_start_time
                    ? "2px solid #d32f2f"
                    : "2px solid #091E4224"
                }}
              />
              {formik.touched.partial_start_time && formik.errors.partial_start_time && (
                <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                  {formik.errors.partial_start_time}
                </span>
              )}

              <CustomText sx={{
                ...textStyles.h1,
                fontSize: 15,
                fontWeight: 500,
                color: "#2C384C",
                pt: 1,
                textAlign: "left",
                mb: 1,
              }}>{t("absence.add.end_time")} <span className="red_asterisk">*</span></CustomText>
              <input
                type="time"
                value={formik.values.partial_end_time}
                onChange={(e) => {
                  formik.setFieldValue("partial_end_time", e.target.value);
                  formik.setFieldTouched("partial_end_time", true);
                }}
                onBlur={formik.handleBlur}
                className="project_input"
                style={{
                  width: "100%",
                  height: 40,
                  border: formik.touched.partial_end_time && formik.errors.partial_end_time
                    ? "2px solid #d32f2f"
                    : "2px solid #091E4224"
                }}
              />
              {formik.touched.partial_end_time && formik.errors.partial_end_time && (
                <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                  {formik.errors.partial_end_time}
                </span>
              )}
            </Box>
          )}

          {/* BUTTONS */}
          <Box sx={{ mt: 2, display: "flex", gap: 2 }}>
            <CustomButton
              size="medium"
              onClick={formik.handleSubmit}
              disabled={adding}
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  {adding ? (
                    <CircularProgress size={18} sx={{ color: "white" }} />
                  ) : (
                    <>
                      <img src={save} alt="" width={16} />
                      {t("absence.add.add_button")}
                    </>
                  )}
                </Box>
              }
            />


          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

export default AddAbsenceDrawer;
